export class InvariantError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'InvariantError';
  }

  static isInvariantError(error: unknown): error is InvariantError {
    return error instanceof InvariantError;
  }
}
